import { render } from "./VFormGroupSelect.vue?vue&type=template&id=64676fca&scoped=true&ts=true"
import script from "./VFormGroupSelect.vue?vue&type=script&lang=ts"
export * from "./VFormGroupSelect.vue?vue&type=script&lang=ts"

import "./VFormGroupSelect.vue?vue&type=style&index=0&id=64676fca&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64676fca"]])

export default __exports__